/* import __COLOCATED_TEMPLATE__ from './seller-profile-body.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

const SECTIONS = {
  ABOUT: 'About',
  PROJECTS: 'Projects',
  NOTES: 'Notes'
};

export default class SellerProfileBody extends Component {
  @service media;

  @tracked activeNavItem = this.media.isMobile ? SECTIONS.ABOUT : SECTIONS.PROJECTS;
  @tracked activeServiceFilterId = -1;
  @tracked completedProjectsCurrentPage = 1;
  @tracked activeProjectsCurrentPage = 1;

  get className() {
    return 'SH-c-seller-profile-freelancer-profile__body';
  }

  get activeProjectsCount() {
    return this.args.activeProjectsCount ?? -1;
  }

  get completedProjectsCount() {
    return this.args.completedProjectsCount ?? -1;
  }

  get companyNotes() {
    const notesUnsorted = this.args.loadProfileNotes.last?.value?.toArray() ?? [];
    return notesUnsorted.sort((noteA, noteB) => noteB.updatedAt - noteA.updatedAt);
  }

  get activeProjects() {
    return this.args.loadActiveApplications.last?.value?.applications;
  }

  get completedProjects() {
    return this.args.loadCompletedApplications.last?.value?.applications;
  }

  get activeProjectsPagination() {
    return this.args.loadActiveApplications.last?.value?.pagination;
  }

  get completedProjectsPagination() {
    return this.args.loadCompletedApplications.last?.value?.pagination;
  }

  get showActivePagination() {
    return !this.args.loadActiveApplications.isRunning && this.activeProjectsPagination?.totalPages > 1;
  }

  get showCompletedPagination() {
    return !this.args.loadCompletedApplications.isRunning && this.completedProjectsPagination?.totalPages > 1;
  }

  get profileNavItems() {
    const navItems = [];

    if (this.media.isMobile) {
      navItems.push({
        title: SECTIONS.ABOUT,
        isActive: () => this.activeNavItem === SECTIONS.ABOUT,
      });
    }

    const projectsCount = this.activeProjectsCount + this.completedProjectsCount;

    navItems.push({
      title: SECTIONS.PROJECTS,
      isActive: () => this.activeNavItem === SECTIONS.PROJECTS,
      count: projectsCount > 0 ? projectsCount : null,
    });

    navItems.push({
      title: SECTIONS.NOTES,
      isActive: () => this.activeNavItem === SECTIONS.NOTES,
      count: this.companyNotes.length,
    });

    return navItems;
  }

  @action
  onProfileNavItemClicked(tab) {
    this.activeNavItem = tab;
  }

  @action
  onServiceFilterClicked(serviceId) {
    this.activeServiceFilterId = serviceId;
    this.completedProjectsCurrentPage = 1;
  }

  @action
  onActiveProjectsPaginationBackward() {
    this.activeProjectsCurrentPage -= 1;
  }

  @action
  onActiveProjectsPaginationForward() {
    this.activeProjectsCurrentPage += 1;
  }

  @action
  onCompletedProjectsPaginationBackward() {
    this.completedProjectsCurrentPage -= 1;
  }

  @action
  onCompletedProjectsPaginationForward() {
    this.completedProjectsCurrentPage += 1;
  }
}
